module.exports = __webpack_public_path__ + "img/2025-0408-01-02.b87c15b6.png";